module.exports = __webpack_public_path__ + "static/media/kingsarcade-title.3964273b.jpg";